import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const ProjectDocuments = () => {
    const newProjectDataItem = useSelector((state) => state.projectSlice.newProjectData);
    const newProjectDataItemDocs = newProjectDataItem.documents;

    
    const handleDocumentClick = (url, documentName) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            console.warn(`No URL provided for ${documentName}`);
        }
    };

    return (
        <Box my={8}>
            <Text color={'#121212'} fontSize={'18px'} mb={4}>Project Documents</Text>
            {newProjectDataItemDocs.map((data, index) => (
                <Box key={index}>
                    {data.brsLink && (
                        <Text 
                            color={'#005E39'} 
                            fontSize={'16px'} 
                            textDecoration={'underline'} 
                            pb={4} 
                            cursor={'pointer'}
                            onClick={() => handleDocumentClick(data.brsLink, 'BRS Document')}
                            _hover={{ color: '#003820' }}
                        >
                            Business Requirements Specification (BRS)
                        </Text>
                    )}
                    {data.srsLink && (
                        <Text 
                            color={'#005E39'} 
                            fontSize={'16px'} 
                            textDecoration={'underline'} 
                            pb={4} 
                            cursor={'pointer'}
                            onClick={() => handleDocumentClick(data.srsLink, 'SRS Document')}
                            _hover={{ color: '#003820' }}
                        >
                            Software Requirements Specification (SRS)
                        </Text>
                    )}
                    {data.manual && (
                        <Text 
                            color={'#005E39'} 
                            fontSize={'16px'} 
                            textDecoration={'underline'} 
                            pb={4} 
                            cursor={'pointer'}
                            onClick={() => handleDocumentClick(data.manual, 'Product Manual')}
                            _hover={{ color: '#003820' }}
                        >
                            Product Manual
                        </Text>
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default ProjectDocuments;